/* eslint-disable */

import React, { useState, useEffect, useCallback } from "react";
import {
    GridActionsCellItem,
    GridAddIcon,
    useGridApiRef,
} from "@mui/x-data-grid-pro";
import { requiredCell } from "../../js/utils/inputValidations";
import DataGridComponent from "../Widgets/DataGridComponent";
import { fetchData, getDownload, excelSpreadsheetMIME, jsonMIME } from "../../js/utils/backend";
import { useSelector, useDispatch } from "react-redux";
import LanguageIcon from "@mui/icons-material/LanguageOutlined";
import { disableKeyCellEdit, TranslationDialog } from "./cst_DataGrid";
import { t } from "react-i18nify";
import { BasicTooltip } from "../Widgets/StyledComponents";
import { updateHighlightedRows } from "../../js/redux/actions/userPref";
import { useLocation } from "react-router-dom";
import { NodeDialog } from "../TreeEditors/TreeEditorComponents";
import * as r from "../../js/constants/routes";
import {
    CircularProgress,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Typography,
} from "@mui/material";
import { HiddenField, VTextField } from "../Widgets/Custom Inputs/CustomInputs";
import { BasicButton, ButtonToolbar } from "../Widgets/Custom Inputs/Buttons";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { useCheckAndRevalidateToken } from "../../js/utils/customHooks";
import { SessionVerificationDialog } from "../Layouts/CommonLayout";
import { DialogActionsForm } from "../Widgets/CustomSurfaces";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { Box } from "@mui/system";
import { VSelectURL } from "../Widgets/Custom Inputs/Select";

const ReferencesDataGrid = ({ label, baseURL, readOnly, specificColumns, srid = false }) => {
    const token = useSelector(state => state.auth.Token);
    const { MetaCompanyManager, CompanyManager, HoldingManager } = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const location = useLocation();
    const currentLocation = location.pathname;
    const apiRef = useGridApiRef();
    specificColumns = specificColumns ? specificColumns(apiRef) : [];

    const locale = useSelector(state => state.i18n.locale);
    const [propsEnglishValue, setOpenEnglishValue] = useState(false);
    const [downloadingFile, setDownloadingFile] = useState(false);
    const beforeCommitRow = useCallback(
        row => {
            if (row.isNew && locale !== "ENG") {
                return new Promise((resolve, reject) => {
                    setOpenEnglishValue({
                        open: true,
                        setOpen: setOpenEnglishValue,
                        resolve,
                        reject,
                        row,
                        label,
                    });
                }).then(englishValue => ({
                    ...row,
                    EnglishValue: englishValue,
                }));
            }
            return row;
        },
        [setOpenEnglishValue, locale, label]
    );

    const cellFocusField = "Key";
    const gridSpecificColumns = [
        {
            field: "Key",
            headerName: t("field.Key"),
            width: 200,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = requiredCell(params, apiRef, "Key", "Key");
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "Value",
            headerName: t("field.Value"),
            width: 300,
            flex: 1,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = requiredCell(params, apiRef, "Value", "Value");
                return { ...params.props, error: hasError };
            },
        },
        ...specificColumns,
    ];

    const [open, setOpen] = useState(false);
    const [rowParams, setRowParams] = useState();
    const [addRequest, setAddRequest] = useState(false);
    const specificActionsColumns = (params, editing, isLocalLoading) => [
        <>
            {!srid ? (MetaCompanyManager || CompanyManager || HoldingManager) && (
                <GridActionsCellItem
                    label={t("common.Translate")}
                    icon={
                        <BasicTooltip title={t("common.Translate")}>
                            <LanguageIcon />
                        </BasicTooltip>
                    }
                    onClick={() => {
                        dispatch(
                            updateHighlightedRows({
                                CurrentLocation: currentLocation,
                                VisitedRowID: params.row.ID,
                            })
                        );
                        setOpen(true);
                        setRowParams(params.row);
                    }}
                    disabled={editing || isLocalLoading}
                />
            ) : null}
        </>,
    ];

    const [hint, setHint] = useState();
    useEffect(() => {
        let isSubscribed = true;

        const fetching = async () => {
            const hintFetched = await fetchData(
                "LookupHint",
                token,
                "List",
                null,
                `PageSize=1&Ref_TableName=${baseURL.substring(1)}`
            );
            if (isSubscribed) {
                if (hintFetched) {
                    setHint(hintFetched?.data?.Data[0]?.Value);
                }
            }
        };
        fetching();
        return () => (isSubscribed = false);
    }, [baseURL, token]);

    return (
        <>
            <TranslationDialog
                label={label}
                open={open}
                setOpen={setOpen}
                rowParams={rowParams}
                baseURL={baseURL}
            />

            <Dialog open={downloadingFile} PaperProps={{
                    style: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                    },
                }}
            >
                <DialogContent>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <CircularProgress
                            size={90}
                            sx={{
                                top: 0,
                                mb: 2,
                            }}
                            color={"secondary"}
                        />
                    </Box>
                </DialogContent>
            </Dialog>

            <DataGridComponent
                apiRef={apiRef}
                isAddDisabled={srid}
                isEditDisabled={srid}
                isDeleteDisabled={srid}
                toolbar={baseURL!=='/Ref_Unit' ? {
                    toolbarFilteringToolsOnly: readOnly && !srid,
                    newAction: (
                        <>
                            {!MetaCompanyManager && !CompanyManager && !HoldingManager && (
                                <ButtonToolbar
                                    titleTooltip={t("common.addNewRef")}
                                    title={t("common.addNewRef")}
                                    startIcon={<GridAddIcon />}
                                    onClick={() => {
                                        setAddRequest({ node: {} });
                                    }}
                                />
                            )}
                            <ButtonToolbar
                                titleTooltip={t(
                                    "common.ExcelExport"
                                )}
                                title={t(
                                    "common.ExcelExport"
                                )}
                                startIcon={
                                    <DownloadOutlinedIcon
                                        sx={{ marginRight: "-4px" }}
                                    />
                                }
                                onClick={() => {
                                    /** The request should absolutely be the same as paginated list for grid, while ommiting specific grid-related things like pageSize and pageNumber */
                                    let url = `${baseURL}/ExportToExcel`;
                                    getDownload(
                                        url,
                                        token,
                                        excelSpreadsheetMIME,
                                        `${baseURL}`,
                                        null,
                                        setDownloadingFile
                                    );
                                }}
                            />
                            <ButtonToolbar
                                titleTooltip={t(
                                    "common.JsonExport"
                                )}
                                title={t(
                                    "common.JsonExport"
                                )}
                                startIcon={
                                    <DownloadOutlinedIcon
                                        sx={{ marginRight: "-4px" }}
                                    />
                                }
                                onClick={() => {
                                    let url = `${baseURL}/ExportToJson`;
                                    getDownload(
                                        url,
                                        token,
                                        jsonMIME,
                                        `${baseURL}`,
                                        null,
                                        setDownloadingFile
                                    );
                                }}
                            />
                        </>
                    ),
                } : {
                    newAction: (
                        <>
                            {!MetaCompanyManager && !CompanyManager && !HoldingManager && !readOnly && (
                                <ButtonToolbar
                                    titleTooltip={t("common.addNewRef")}
                                    title={t("common.addNewRef")}
                                    startIcon={<GridAddIcon />}
                                    onClick={() => {
                                        setAddRequest({ node: {} });
                                    }}
                                />
                            )}
                            <ButtonToolbar
                                titleTooltip={t(
                                    "common.ExcelExport"
                                )}
                                title={t(
                                    "common.ExcelExport"
                                )}
                                startIcon={
                                    <DownloadOutlinedIcon
                                        sx={{ marginRight: "-4px" }}
                                    />
                                }
                                onClick={() => {
                                    /** The request should absolutely be the same as paginated list for grid, while ommiting specific grid-related things like pageSize and pageNumber */
                                    let url = `${baseURL}/ExportToExcel`;
                                    getDownload(
                                        url,
                                        token,
                                        excelSpreadsheetMIME,
                                        `${baseURL}`,
                                        null,
                                        setDownloadingFile
                                    );
                                }}
                            />
                            <ButtonToolbar
                                titleTooltip={t(
                                    "common.JsonExport"
                                )}
                                title={t(
                                    "common.JsonExport"
                                )}
                                startIcon={
                                    <DownloadOutlinedIcon
                                        sx={{ marginRight: "-4px" }}
                                    />
                                }
                                onClick={() => {
                                    let url = `${baseURL}/ExportToJson`;
                                    getDownload(
                                        url,
                                        token,
                                        jsonMIME,
                                        `${baseURL}`,
                                        null,
                                        setDownloadingFile
                                    );
                                }}
                            />
                        </>
                    ),
                }}
                hideActionColumn={readOnly}
                baseURL={baseURL}
                cellFocusField={cellFocusField}
                label={label}
                gridSpecificColumns={gridSpecificColumns}
                specificActionsColumns={specificActionsColumns}
                hint={hint}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "Value", sort: "asc" }],
                    },
                }}
                isCellEditable={(params) => disableKeyCellEdit(params)}
                beforeCommitRow={beforeCommitRow}
            />
            <NewRefDialog
                reference={label}
                route={baseURL}
                editNewRefOpen={addRequest}
                seteditNewRefOpen={setAddRequest}
            />
            <EnglishValueDialog {...propsEnglishValue} />
        </>
    );
};

export default ReferencesDataGrid;

export const EnglishValueDialog = ({
    open,
    setOpen,
    resolve,
    reject,
    row,
    label,
}) => {
    const methods = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const { reset, handleSubmit, formState } = methods;

    ////////////////////////////////// TOKEN REVALIDATION \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
    const [sessionVerification, setSessionVerification] = useState(false);
    useCheckAndRevalidateToken(setSessionVerification, [
        formState.isSubmitting,
    ]);
    ////////////////////////////////// TOKEN REVALIDATION \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

    const manageSubmit = async data => {
        setOpen(false);
        reset();
        resolve(data.EnglishValue);
    };
    const manageCancel = useCallback(() => {
        setOpen(false);
        reset();
        reject();
    }, [reject, setOpen, reset]);

    return (
        <Dialog open={Boolean(open)} sx={{ w: 1 }} fullWidth>
            {sessionVerification ? (
                <SessionVerificationDialog
                    sessionVerification={sessionVerification}
                />
            ) : null}
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(manageSubmit)}>
                    <DialogTitle sx={{ typography: "body1", display: "flex" }}>
                        {t("common.AddingEnglish")}{" "}
                        <Typography
                            color="secondary"
                            sx={{ ml: 1 / 2, textTransform: "lowercase" }}
                        >
                            {label}
                        </Typography>{" "}
                        : {row?.Value}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText sx={{ mb: 2 }} />
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <VTextField
                                    label={`${t("field.Value")}: ${t(
                                        "languages.English"
                                    )}`}
                                    fieldName={"EnglishValue"}
                                    validation={{
                                        required: {
                                            value: true,
                                            message: t(
                                                "input.validation.required"
                                            ),
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActionsForm>
                        <BasicButton
                            type="button"
                            style={{
                                position: "relative",
                                margin: 4,
                            }}
                            onClick={manageCancel}
                        >
                            {t("common.Cancel")}
                        </BasicButton>
                        <BasicButton
                            type="submit"
                            style={{ margin: 4, marginRight: 0 }}
                        >
                            {t("common.Save")}
                        </BasicButton>
                    </DialogActionsForm>
                </form>
            </FormProvider>
        </Dialog>
    );
};

export const NewRefDialog = ({
    editNewRefOpen,
    seteditNewRefOpen,
    onFormClose,
    reference,
    route,
}) => {
    const form = useCallback(
        () => <NewRefForm reference={reference} route={route} />,
        [reference, route]
    );
    return Boolean(editNewRefOpen) ? (
        <NodeDialog
            Form={form}
            label={t("common.newRef").toLowerCase()}
            open={Boolean(editNewRefOpen)}
            rowParams={editNewRefOpen}
            setOpen={seteditNewRefOpen}
            URL={r.request}
            onClose={(node, isEditing) => onFormClose(node, isEditing)}
        />
    ) : null;
};

export const NewRefForm = ({ reference = "", route = "", node = null }) => {
    const token = useSelector(state => state.auth.Token);
    const { reset } = useFormContext();
    const requestNewRef = node?.RequestNewRef;
    const analysisGroupID =
        requestNewRef?.Ref_AnalysisGroupID ??
        requestNewRef?.Ref_AnalysisGroup_select?.ObjectID ??
        null;
    const [analysisGroupDefaultValue, setAnalysisGroupDefaultValue] = useState(
        requestNewRef?.Ref_AnalysisGroup_select ?? null
    );

    useEffect(() => {
        let isSubscribed = true;

        const fetchAnalysisGroup = async () => {
            if (!analysisGroupID) {
                if (isSubscribed) {
                    setAnalysisGroupDefaultValue(null);
                }
                return;
            }

            if (requestNewRef?.Ref_AnalysisGroup_select) {
                if (isSubscribed) {
                    setAnalysisGroupDefaultValue(requestNewRef.Ref_AnalysisGroup_select);
                }
                return;
            }

            const analysisGroupFetched = await fetchData(
                r.analysisGroup.route,
                token,
                "ID",
                analysisGroupID,
                "",
                "",
                true
            );

            if (isSubscribed) {
                const fetchedAnalysisGroup = analysisGroupFetched?.data;
                setAnalysisGroupDefaultValue(
                    fetchedAnalysisGroup
                        ? {
                              ...fetchedAnalysisGroup,
                              ObjectID:
                                  fetchedAnalysisGroup.ObjectID ??
                                  fetchedAnalysisGroup.ID,
                          }
                        : null
                );
            }
        };

        fetchAnalysisGroup();
        return () => (isSubscribed = false);
    }, [analysisGroupID, requestNewRef, token]);

    useEffect(() => {
        if (requestNewRef) {
            reset({
                ID: node.ID,
                RequestType: "NEWREF",
                RequestNewRef: {
                    ReferenceTitle: requestNewRef.ReferenceTitle ?? reference,
                    ReferenceRoute: requestNewRef.ReferenceRoute ?? route,
                    Key: requestNewRef.Key,
                    Value: requestNewRef.Value,
                    Translations: {
                        French: requestNewRef.Translations?.French ?? "",
                        Dutch: requestNewRef.Translations?.Dutch ?? "",
                        German: requestNewRef.Translations?.German ?? "",
                        Portuguese: requestNewRef.Translations?.Portuguese ?? "",
                        Spanish: requestNewRef.Translations?.Spanish ?? "",
                    },
                    Note: requestNewRef.Note ?? "",
                    Ref_AnalysisGroupID: analysisGroupID,
                },
            });
        }
    }, [analysisGroupID, node, reference, requestNewRef, reset]);

    return (
        <Grid container spacing={2}>
            <HiddenField fieldName={"RequestType"} defaultValue="NEWREF" />
            <HiddenField fieldName={"RequestNewRef.ReferenceRoute"} defaultValue={route} />
            {node?.ID ? <HiddenField fieldName={"ID"} defaultValue={node.ID} /> : null}
            <Grid item xs={12}>
                <VTextField
                    label={t("field.Reference")}
                    fieldName={"RequestNewRef.ReferenceTitle"}
                    defaultValue={reference}
                    disabled
                />
            </Grid>
            <Grid item xs={12}>
                <VTextField
                    label={t("field.Key")}
                    fieldName={"RequestNewRef.Key"}
                    validation={{
                        required: {
                            value: true,
                            message: t("input.validation.required"),
                        },
                    }}
                />
            </Grid>

            {/* AKASH HSENV-35 */}
            <Grid item xs={12}>
             <VSelectURL
                      key={analysisGroupDefaultValue?.ObjectID ?? analysisGroupID ?? "empty-analysis-group"}
                    // sx={{ mb:2, mt:4 }}
                    label={t("field.AnalysisGroup")}
                    URL={r.analysisGroup.route}
                    fieldName={"RequestNewRef.Ref_AnalysisGroupID"}
                    validation={reference === "Analytes" ? {
                        required: {
                            value: true,
                            message: t("input.validation.required"),
                        },
                    } : {}}
                    defaultValue={analysisGroupDefaultValue}
                />
            </Grid> 

            <Grid item xs={12}>
                <VTextField
                    label={`${t("field.Value")}: ${t("languages.English")}`}
                    fieldName={"RequestNewRef.Value"}
                    validation={{
                        required: {
                            value: true,
                            message: t("input.validation.required"),
                        },
                    }}
                />
            </Grid>
            <Grid item xs={12}>
                <VTextField
                    label={`${t("field.Value")}: ${t("languages.French")}`}
                    fieldName={"RequestNewRef.Translations.French"}
                />
            </Grid>
            <Grid item xs={12}>
                <VTextField
                    label={`${t("field.Value")}: ${t("languages.Dutch")}`}
                    fieldName={"RequestNewRef.Translations.Dutch"}
                />
            </Grid>
            <Grid item xs={12}>
                <VTextField
                    label={`${t("field.Value")}: ${t("languages.German")}`}
                    fieldName={"RequestNewRef.Translations.German"}
                />
            </Grid>
            <Grid item xs={12}>
                <VTextField
                    label={`${t("field.Value")}: ${t("languages.Portuguese")}`}
                    fieldName={"RequestNewRef.Translations.Portuguese"}
                />
            </Grid>
            <Grid item xs={12}>
                <VTextField
                    label={`${t("field.Value")}: ${t("languages.Spanish")}`}
                    fieldName={"RequestNewRef.Translations.Spanish"}
                />
            </Grid>
            <Grid item xs={12}>
                <VTextField
                    label={t("field.AdditionalExplanations")}
                    fieldName={"RequestNewRef.Note"}
                    maxCar={1000}
                />
            </Grid>
        </Grid>
    );
};
